<template>
    <div class="container let-space-1">
        <div class="card card-body mb-2">
            <div class="d-flex">
                <span>
                    <i class="fas fa-id-card-alt icon-size text-primary pr-2"></i>
                </span>
                <span>個人情報</span>
                <div class="text-right ml-auto">
                    <button type="button" @click="openPrivateInfo()" class="btn btn-link p-0">詳細</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        openPrivateInfo () {
            this.$parent.openPrivateInfo()
        },
    }

}
</script>

<style>

</style>
